import React from "react";
import { createPortal } from "react-dom";
import { getReactPortalRoot } from "../utils/reactPortalRoot.js";

const GHOST_HEADER_CLASS_NAME = "border border-slate-200 bg-slate-50/95 px-2 py-1.5 text-left text-[9px] font-semibold uppercase tracking-[0.14em] text-slate-500";

export default function ColumnHeaderDragOverlay({ dragOverlay = null }) {
  const portalRoot = getReactPortalRoot();
  if (!dragOverlay || !(portalRoot instanceof HTMLElement)) {
    return null;
  }

  const {
    height,
    insertionLine,
    label,
    offsetX,
    offsetY,
    pointerX,
    pointerY,
    width,
  } = dragOverlay;

  const ghostLeft = pointerX - offsetX;
  const ghostTop = pointerY - offsetY;

  return createPortal(
    <div data-column-drag-overlay="true">
      {insertionLine ? (
        <div
          aria-hidden="true"
          className="pointer-events-none fixed z-[60] w-0.5 rounded-full bg-accent shadow-[0_0_0_1px_rgba(15,118,110,0.18)]"
          data-column-insertion-line="true"
          style={{
            height: `${insertionLine.height}px`,
            left: `${insertionLine.left}px`,
            top: `${insertionLine.top}px`,
          }}
        />
      ) : null}
      <div
        aria-hidden="true"
        className={[
          GHOST_HEADER_CLASS_NAME,
          "pointer-events-none fixed z-[61] flex cursor-grabbing items-center overflow-hidden rounded-sm shadow-[0_12px_28px_rgba(15,23,42,0.18)] ring-2 ring-accent/35",
        ].join(" ")}
        data-column-drag-ghost="true"
        style={{
          height: `${height}px`,
          left: `${ghostLeft}px`,
          top: `${ghostTop}px`,
          width: `${width}px`,
        }}
      >
        <span className="truncate">{label}</span>
      </div>
    </div>,
    portalRoot,
  );
}
